module.exports = __webpack_public_path__ + "img/arrow-right-large.526602d9.svg";